var AbstractAttributesDialog = require("attributes/AbstractAttributesDialog");
var Utils = require("common/Utils");

/**
 * @extends {AbstractAttributesDialog}
 * @class
 */
function TOTPTokenDialog() {
    var $htmlForm = $(require("html!./totp_token_dialog.html"));
    AbstractAttributesDialog.call(this, $htmlForm);

    this.setSubmitEvent("TOTPSettingsDelegate", "post-auth-token");

    var super_promptForAttributes = this.promptForAttributes;
    this.promptForAttributes = function(launchCallback) {
        var attributes = {
            session : [{
                id : "token",
                label : $.t("common::totp.token.label"),
                value : "",
                format : 0
            }]
        };

        return super_promptForAttributes(attributes, "", launchCallback, $.t("common::totp.title"), false);
    };
}

Utils.inherits(TOTPTokenDialog, AbstractAttributesDialog);

module.exports = TOTPTokenDialog;